import type { CSSProperties } from 'react';
import { BRAND_LOGO_DATA_URL } from './brandLogoData';

export const BRAND = { systemName: '墨睿科技EAM系统', companyName: '广东墨睿科技有限公司', englishName: 'MORION · EAM' } as const;

export function BrandMark({ size = 34 }: { size?: number }) {
  return <span className="brand-mark" role="img" aria-label={`${BRAND.companyName}标志`} style={{ '--brand-mark-size': `${size}px` } as CSSProperties}>
    <span className="brand-mark-crop" aria-hidden="true"><img className="brand-mark-image" src={BRAND_LOGO_DATA_URL} alt="" /></span>
  </span>;
}
